<template>
  <v-app-bar
    flat
    border
    class="px-3 px-sm-4"
  >
    <!--  logo-icon+title  -->
    <div
      :class="$vuetify.display.name"
      style="min-width: 180px"
    >
      <nuxt-link
        to="/"
        class="d-flex align-center"
      >
        <v-icon
          icon="$logo"
          size="32"
          class="mr-4"
        />
        <span
          class="text-beton80"
          style="font-size: 24px; font-weight: bold"
          >FINFLOW</span
        >
      </nuxt-link>
    </div>

    <v-spacer />

    <template v-if="pageTitle">
      <div
        class="text-beton text-wrap"
        :class="pageTitle.length > 30 ? 'text-h2' : 'text-h1'"
      >
        {{ pageTitle }}
      </div>
      <v-spacer />
    </template>

    <!--  profile button and menu dropdown  -->
    <x-drop-down-button
      v-if="authService.isLoggedIn && !!userService.currentUser"
      :items="profileMenuItems"
      :visible-activator="true"
      :dropdown-icon="!$vuetify.display.xs"
      :button-min-width="!$vuetify.display.xs ? '190' : undefined"
      button-max-width="fit-content"
      @select="selectProfileMenuItem"
    >
      <v-avatar
        class="avatar"
        :size="32"
      >
        {{ avatarLetters }}
      </v-avatar>

      <div
        v-if="$vuetify.display.smAndUp"
        class="d-flex flex-column text-left"
        :style="{ maxWidth: `${245 - 100}px` }"
      >
        <div
          v-if="userService.currentUser"
          class="text-body-1 text-beton text-overflow"
        >
          {{ userService.fullName }}
        </div>
      </div>
    </x-drop-down-button>
  </v-app-bar>
</template>

<script setup lang="ts">
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { UserService } from '~/app-modules/user/services/user.service';
import { TItem } from '~/app-modules/ux-system/components/drop-down.vue';

defineOptions({
  name: 'AppLayoutMainHeader',
});

const authService = useIOC(AuthService);
const userService = useIOC(UserService);
const pageTitle = useState<string>('pageTitle');

const avatarLetters = computed(
  () =>
    userService.currentUser &&
    `${userService.currentUser.firstName[0]}${userService.currentUser.lastName[0]}`,
);

const profileMenuItems: Array<TItem> = [{ label: 'Выход', icon: '$logout', value: 'logout' }];

async function selectProfileMenuItem(item: TItem) {
  switch (item.value) {
    case 'logout': {
      authService.logout();
      await useRouter().push('/auth');
      break;
    }
    default:
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  margin-right: 6px;
  color: white;
  @include get-text-styles(h4);
  font-stretch: condensed;
  background: linear-gradient(18deg, #194a7f 15.64%, #246da4 63.13%, #2e8bc4 91.06%);
}
</style>
